import UEditor from './UEditor.vue'
export default UEditor


// WEBPACK FOOTER //
// ./src/components/UEditor/index.js